import axios from "@utils/axios-instance";
import type {
  SchedulerResponse,
  CreateSchedulerRequest,
  UpdateSchedulerRequest,
} from "@/models/scheduler.model";

const create = async (data: CreateSchedulerRequest): Promise<SchedulerResponse> => {
  const response = await axios.post("/scheduler", data);
  return response.data;
};

const getAll = async (): Promise<SchedulerResponse[]> => {
  const response = await axios.get("/scheduler");
  return response.data.data;
};

const getById = async (id: number): Promise<SchedulerResponse> => {
  const response = await axios.get(`/scheduler/${id}`);
  return response.data;
};

const updateById = async (
  id: number,
  data: UpdateSchedulerRequest
): Promise<SchedulerResponse> => {
  const response = await axios.put(`/scheduler/${id}`, data);
  return response.data;
};

const deleteById = async (id: number): Promise<void> => {
  await axios.delete(`/scheduler/${id}`);
};

export default {
  create,
  getAll,
  getById,
  updateById,
  deleteById,
};
